import axios from "../../config/axiosConfig";
import { getGrayJobReceiveReturnTransactionTakaNo } from './gray-job-receive-retun-transaction-actions';
import { getProductions } from './production-entry-actions';
import { getProductionTransaction, getProductionTransactionTakaNo } from './production-transaction-actions';
import { CREATE_GRAY_JOB_RECEIVE_RETURN, GET_GRAY_JOB_RECEIVE_RETURNS, GRAY_JOB_RECEIVE_RETURN_REQUEST, UPDATE_GRAY_JOB_RECEIVE_RETURN, DELETE_GRAY_JOB_RECEIVE_RETURN, GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE } from "../types";

export const getGrayJobReceiveReturns = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/gray-job-return/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_GRAY_JOB_RECEIVE_RETURNS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createGrayJobReceiveReturn = (grayJobReceive) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST });
      const newGrayJobReceiveReturn = {
        ...grayJobReceive
      };
      return axios.post("/gray-job-return/add", newGrayJobReceiveReturn,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_GRAY_JOB_RECEIVE_RETURN, payload: response.data });
          dispatch(getGrayJobReceiveReturnTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE,
            error: "Gray Job Receive create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateGrayJobReceiveReturn = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST });
      const { auth } = getState();
      return axios.put("/gray-job-return/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_GRAY_JOB_RECEIVE_RETURN,
            payload: { id, data: response.data },
          });
          dispatch(getGrayJobReceiveReturnTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE,
            error: "Gray Job Receive update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteGrayJobReceiveReturn = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST });
      const { auth } = getState();
      return axios.delete(`/gray-job-return/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_GRAY_JOB_RECEIVE_RETURN, id: id });
          dispatch(getGrayJobReceiveReturnTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

// export const printEwayGrayJobReceiveReturn = (ewaybillNumber) => {
//   return async (dispatch, getState) => {
//     try {
//       // dispatch({ type: SALES_BILL_REQUEST });
//       console.log("Printing E-Way Bill with number:", ewaybillNumber);
//       const { auth } = getState();
//       let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, ewaybillNumber };
//       console.log("Params for printing E-Way Bill:", params);
//       return axios.get("/gray-job-return/print-eway-bill", { params }).then((response) => {
//         return response.data;
//         // if (response.data) {
//         //   dispatch({ type: GET_SALES_BILLS, payload: response.data });
//         // }
//       }).catch((error) => {
//         console.error(error);
//         dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });  
//       });
//     } catch (error) {
//       console.error(error);
//       dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });
//     }
//   };
// };

// export const generateEwayGrayJobReceiveReturn = (id) => {
//   return async (dispatch, getState) => {
//     try {
//       dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST });
//       const { auth } = getState();
//       // let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
//       // console.log('params', params);
//       // let data = {};
      
//       return axios.get(`/gray-job-return/generate-eway-bill/${id}`,{ params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
//         if (response.data) {
//           // dispatch({ type: CANCEL_EWAY_BILL, id: id });
//           dispatch({
//             type: UPDATE_GRAY_JOB_RECEIVE_RETURN,
//             payload: { id, data: response.data },
//           });
//         }
//         return response;
//       }).catch((error) => {
//         console.log('generate eway bill error',error);
        
//         console.error(error);
//         dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });  
//         throw error;
//       });
//     } catch (error) {
//       console.error(error);
//       dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });
//       throw error;
//     }
//   };
// };

// export const cancelEwayGrayJobReceiveReturn = (id, data) => {
//   return async (dispatch, getState) => {
//     try {
//       dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST });
//       const { auth } = getState();
//       return axios.post(`/gray-job-return/cancel-eway-bill/${id}`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
//         if (response.data) {
//           dispatch({
//             type: UPDATE_GRAY_JOB_RECEIVE_RETURN,
//             payload: { id, data: response.data },
//           });
//         }
//         return response;
//       }).catch((error) => {
//         console.error(error);
//         dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });  
//         throw error;
//       });
//     } catch (error) {
//       console.error(error);
//       dispatch({ type: GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE, error: error.message });
//       throw error;
//     }
//   };
// };